/**
 * @generated SignedSource<<7940f5b02ac5ad8f83278838dbaf8a6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedDeals_artist$data = {
  readonly featuredDeals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DealListItem_featureddeal">;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "FeaturedDeals_artist";
};
export type FeaturedDeals_artist$key = {
  readonly " $data"?: FeaturedDeals_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeaturedDeals_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeaturedDeals_artist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FeaturedDealNodeConnection",
      "kind": "LinkedField",
      "name": "featuredDeals",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FeaturedDealNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FeaturedDealNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DealListItem_featureddeal"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "6f38ebea2c41eeb6d27969fa0f135c89";

export default node;
